import { initializeTable } from '../tables';
import { hasPermission } from '../../utils';
import RowContextMenuButtonColumn from '../formatters/RowContextMenuButtonColumn';
import { addAlert } from '../../alerts';
import { deletePrompt } from '../../prompts.js';

export default function initializeOfferListTable({ ...options }) {
    const rootElement = document.querySelector('#offerTable');
    if (!rootElement) return;

    const pillsContainerSelector = '.active-filters-container';

    const canManage = hasPermission('users.manage_offers');

    const table = initializeTable({
        tableElement: rootElement,
        filtersElement: document.querySelector('#offerFilters .form-fields'),
        ajaxURL: rootElement.dataset.ajaxUrl,
        pillsConfig: {
            containerSelector: pillsContainerSelector,
            ignoreFields: [],
        },
        rowContextMenu: function (e, row) {
            const rowData = row.getData();

            const menu = [
                canManage
                    ? {
                          label: gettext('Edytuj'),
                          action: function (e, row) {
                              if (window.offerPopup) {
                                  window.offerPopup.openInEditMode(rowData.id);
                              } else {
                                  console.error(
                                      'Offer popup module not found.',
                                  );
                              }
                          },
                      }
                    : null,
                canManage
                    ? {
                          label: gettext('Usuń'),
                          action: function (e, row) {
                              deletePrompt({
                                  options: {
                                      html:
                                          gettext(
                                              'Czy na pewno chcesz usunąć tę ofertę?',
                                          ) +
                                          '<br>' +
                                          gettext(
                                              'Spowoduje to również usunięcie produktu ze sklepu.',
                                          ),
                                  },
                                  url: rowData.delete_url,
                                  successAction: function () {
                                      addAlert(
                                          'success',
                                          gettext(
                                              'Oferta została pomyślnie usunięta.',
                                          ),
                                      );
                                      document.dispatchEvent(
                                          new Event('offerUpdated'),
                                      );
                                  },
                                  failedAction: function (error) {
                                      const message =
                                          error?.data?.message ||
                                          error?.message ||
                                          gettext(
                                              'Wystąpił błąd podczas usuwania oferty.',
                                          );
                                      addAlert('error', message);
                                  },
                              });
                          },
                      }
                    : null,
            ].filter((item) => item);
            return menu;
        },
        columns: [
            { title: '#', formatter: 'rownum', width: 60, headerSort: false },
            {
                title: gettext('Kod'),
                field: 'component.enova_id',
                resizable: false,
            },
            {
                title: gettext('Grupa'),
                field: 'component.enova_data.group',
                resizable: false,
            },
            {
                title: gettext('Typ'),
                field: 'component.enova_data.type',
                resizable: false,
            },
            {
                title: gettext('Producent'),
                field: 'component.enova_data.manufacturer',
                resizable: false,
            },
            {
                title: gettext('Model'),
                field: 'component.enova_data.model',
                resizable: false,
            },
            {
                title: gettext('Produkt'),
                field: 'woocommerce_id',
                resizable: false,
                headerSort: true,
                width: 120,
                formatter: function (cell) {
                    const rowData = cell.getData();
                    const url = rowData.product_url;
                    const id = rowData.woocommerce_id;
                    if (!url || !id) return id || '';
                    return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="cell-icon-link"><img src="/static/images/external-link.svg" alt="${gettext('Link')}" class="icon-left"><span class="link-text">${id}</span></a>`;
                },
            },
            {
                title: gettext('Status'),
                field: 'status',
                resizable: false,
                width: 100,
                formatter: function (cell) {
                    const statusValue = cell.getData().status;
                    const statusMap = {
                        DRAFT: gettext('Szkic'),
                        PUBLISHED: gettext('Opublikowana'),
                        ARCHIVED: gettext('Zarchiwizowana'),
                    };
                    return statusMap[statusValue] || statusValue;
                },
            },
            {
                title: gettext('Akcja'),
                resizable: false,
                headerSort: false,
                width: 100,
                formatter: RowContextMenuButtonColumn,
                visible: canManage,
            },
        ],
        ...options,
    });

    document.addEventListener('offerUpdated', () => {
        if (table) {
            const baseUrl = table.options.ajaxURL;
            const cacheBustingUrl = `${baseUrl}?_=${new Date().getTime()}`;
            table.setData(cacheBustingUrl);
        }
    });
}
